import { render } from "./ListMerged.vue?vue&type=template&id=e4b638a4"
import script from "./ListMerged.vue?vue&type=script&lang=js"
export * from "./ListMerged.vue?vue&type=script&lang=js"

import "./ListMerged.vue?vue&type=style&index=0&id=e4b638a4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__